import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  tone?: "dark" | "light";
}

export default function Breadcrumb({ items, tone = "dark" }: BreadcrumbProps) {
  const isLight = tone === "light";
  return (
    <nav
      aria-label="面包屑导航"
      className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm"
    >
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {index > 0 && (
            <i
              className={`ri-arrow-right-s-line ${
                isLight ? "text-background-500" : "text-foreground-300"
              }`}
            />
          )}
          {item.to ? (
            <Link
              to={item.to}
              className={`transition-colors ${
                isLight
                  ? "text-background-300 hover:text-accent-400"
                  : "text-foreground-500 hover:text-accent-600"
              }`}
            >
              {item.label}
            </Link>
          ) : (
            <span className={isLight ? "text-background-50" : "text-foreground-800"}>
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}